<div *ngIf="localService.languageContent && localService.languageContent.billing">
  <div class="row display-type">
    <div class="col-6">
      <button type="button" class="btn btn-secondary" [ngClass]="itemsDisplayType == 2 ? ' active' : 'inactive'"
        (click)="onAction(1)" [disabled]="itemsDisplayType == 2">{{localService.languageContent.billing.businesses}}</button>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-secondary" [ngClass]="itemsDisplayType == 3 ? ' active' : 'inactive'"
        (click)="onAction(2)" [disabled]="itemsDisplayType == 3">{{localService.languageContent.billing.products}}</button>
    </div>
  </div>
  <div>
    <app-items *ngIf="itemsDisplayType == 2" [countryCode]="ctryCode" [itemsDisplayType]="itemsDisplayType"></app-items>
    <app-items *ngIf="itemsDisplayType == 3" [countryCode]="ctryCode" [itemsDisplayType]="itemsDisplayType"></app-items>
  </div>
</div>